// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1r1OZ","author":"Table_author__1u3iR","authorImage":"Table_authorImage__2cwX3","unreadRow":"Table_unreadRow__369XY"};